import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import { 
  CLEAR_VIEW, 
  CLEAR_VIEWS, 
  FLAG_GETTING_VIEWS, 
  FLAG_VIEW_ACTIVITY, 
  GET_VIEW, 
  GET_VIEWS 
} from '../../../actions/types/security/View';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_VIEWS:
      return state.setIn(['all', 'loading'], payload);
    case GET_VIEWS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_VIEWS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_VIEW_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_VIEW:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_VIEW:
      return state.setIn(['current', 'content'], INITIAL_STATE.getIn(['current', 'content']));
    default:
      return state;
  }
};
